const GET_PAYMENTS = 'webservice/get-payments';

module.exports = {
    getPaymentsDetails: function (params) {
        return window.axios.get(GET_PAYMENTS, {params: params});
    },
};